import cookies from 'js-cookie'
import { getPlatform } from '@common-libs/tj-utils/platform'
import { getChannelInfo } from '@common-libs/tj-channel'
import { trackReportLog } from '@/business/report'

/**
 * 按当前平台 + 渠道计算 clientAgent（不写 cookie）
 * 规则与 pwa_mobile setClientAgent 保持一致
 */
export function resolveClientAgent() {
  const channelInfo = getChannelInfo()
  let clientAgent = ''
  const platformValue = getPlatform()
  if (platformValue.isWxMpEnv) {
    if (channelInfo.isCtrip) {
      clientAgent = 'C_wx'
    } else if (channelInfo.isQunar) {
      clientAgent = 'Q_wx'
    } else if (channelInfo.isTujia) {
      clientAgent = 'T_wx'
    } else if (channelInfo.isMayi) {
      clientAgent = 'M_wx'
    }
  } else if (platformValue.isAliMpEnv) {
    if (channelInfo.isCtrip) {
      clientAgent = 'C_alipay'
    } else if (channelInfo.isTujia) {
      clientAgent = 'T_alipay'
    } else if (channelInfo.isMayi) {
      clientAgent = 'M_alipay'
    }
  } else if (platformValue.isBaiduMpEnv) {
    clientAgent = 'T_baidu'
  } else if (platformValue.isJdAppEnv) {
    clientAgent = 'T_jdcom'
  } else {
    if (channelInfo.isCtrip) {
      clientAgent = 'C_h5'
    } else if (channelInfo.isTujia) {
      clientAgent = 'T_h5'
    } else if (channelInfo.isQunar) {
      clientAgent = 'Q_h5'
    } else if (channelInfo.isMayi) {
      clientAgent = 'M_h5'
    } else {
      clientAgent = 'other_h5'
    }
  }
  return clientAgent
}

/** cookie 中的 clientAgent 与当前端计算结果不一致时上报 */
export function reportClientAgentMismatchIfNeeded() {
  try {
    const cookieClientAgent = cookies.get('clientAgent') || ''
    const expectedClientAgent = resolveClientAgent()
    if (cookieClientAgent !== expectedClientAgent) {
      trackReportLog('FE_CLIENT_AGENT_MISMATCH', {
        cookieClientAgent,
        expectedClientAgent,
        current_url: window.location.href,
        project: 'fe-cms-client'
      })
    }
  } catch (e) {
    // ignore
  }
}
